import React from 'react';
import { Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { isApiError } from '@helpers/index';
import { useCancelUserReportMutation } from '@services/userreport/userreport.service';

type Props = { reportId: number; canCancel: boolean };

const CancelReportExportButton = ({ reportId, canCancel }: Props) => {
  const { t } = useTranslation();
  const [cancelReport, { isLoading }] = useCancelUserReportMutation();

  if (!canCancel) return null;

  const handleCancel = async () => {
    try {
      await cancelReport(reportId).unwrap();
      message.success(t('exportReports.cancelRequested'));
    } catch (error) {
      if (isApiError(error) && error.data.msg === 'report_not_cancelable') {
        message.warning(t('exportReports.cancelNotAllowed'));
        return;
      }
      message.error(t('exportReports.cancelError'));
    }
  };

  return (
    <Button danger size="small" loading={isLoading} onClick={handleCancel}>
      {t('exportReports.cancel')}
    </Button>
  );
};

export default CancelReportExportButton;
